export { default } from "./empowerAlertPopUp";
